// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3PTxe","question":"Question_question__3yq3f","description":"Question_description__TPPFh"};